// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

export const constants = {
    footer: {
        offsetTop: 48,
    },
    searchInput: {
        breakpoints: {
            lg: 1280,
        },
    },
    cartLine: {
        breakpoints: {
            md: 1200,
            xs: "xs",
        },
    },
    productList: {
        xSortAndFilter: {
            screen: "isTabletScreen",
            breakpoint: "md",
        },
    },
    productGridView: {
        desktop: {
            width: 308,
            height: 308,
        },
        tablet: {
            width: 230,
            height: 230,
        },
        mobile: {
            width: 280,
            height: 280,
        },
    },
    myAccountListPageFilter: {
        breakpoints: { xSmall: 380 },
    },
};

export const EMPTY_VALUE = "- -";
export const DivWrapper = `div[class^="Wrapper"]`;

export const XNGAGE_ELEMENTS = "Xngage" as any;

export const sharedDateTimeOptions: Intl.DateTimeFormatOptions = {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
};

export const placeHolders = {
    email: "eg. example@gmail.com",
    phone: "( ___ ) ___ - ____",
};

export const USA_ABBR = "US";

export const PLP_BREAKPOINT = 900;

export const CHECKOUT_BREAKPOINT = 1024;
export const ShippingFormId = "ShippingForm";
export const BillingFormId = "BillingForm";
export const ShippingMethodFormId = "shippingMethodForm";
export const HEADER_BREAKPOINT = 350;
